import gql from 'graphql-tag';
// import { getFYList } from '../../../util/shared/tmc-global';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const feeFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  feeNumber: '',
  feeAmount: '',
  feeDescription: '',
  effectiveDate: '',
  fiscalYear: '',
  isPaid: '',
  paymentNumber: '',
  paymentDate: '',
  taxInquiryTransaction: {
    _id: '',
    name1: '',
    name2: '',
  },
};
export const taxFee = {
  namespaced: true,
  state: () => ({
    isDialog: false,
    selectedItems: [],
    selectedItemsBrowsePaidBy: [],
    selectedPaidByItems: [],
    selectedItemsStatusCodes: [],
    slectedComments: [],
    slectedDelq: [],
    taxRollFeesTable: [],
    isItOmitOrSa: false,
  }),
  mutations: {
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setSelectedItemsBrowsePaidBy(state, items) {
      state.selectedItemsBrowsePaidBy = items;
    },
    setSelectedPaidByItems(state, items) {
      state.selectedPaidByItems = items;
    },
    setSelectedItemsStatusCodes(state, items) {
      state.selectedItemsStatusCodes = items;
    },
    setComments(state, items) {
      state.slectedComments = items;
    },
    setDelq(state, items) {
      state.slectedDelq = items;
    },
    setTaxRollFeesTable(state, items) {
      state.taxRollFeesTable = items;
    },
    setIsItOmitOrSa(state, items) {
      state.isItOmitOrSa = items;
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    async loadTaxRollFeesTable({ commit, dispatch }, { criteria, baseCrudKey, postProcessTrans }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxFees($criteria: taxFeesCriteriaType) {
            taxFees(criteria: $criteria) {
              ${fieldsToGqlString(feeFields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxFees } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxFees) : taxFees;
          commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Tax Fees.', { root: true });
      }
      return results.data.taxFees;
    },
    async taxFeesBasedOnIds({ commit, dispatch },
      {
        criteria, baseCrudKey, postProcessTrans, signal,
      }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxFeesBasedOnIds($criteria: taxFeesBasedOnIdsCriteriaType) {
            taxFeesBasedOnIds(criteria: $criteria) {
              ${fieldsToGqlString(feeFields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
          context: {
            fetchOptions: {
              signal,
            },
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxFeesBasedOnIds } = results.data;
          const processedTransData = postProcessTrans
            ? postProcessTrans(taxFeesBasedOnIds) : taxFeesBasedOnIds;
          commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
          return processedTransData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Tax Fees.', { root: true });
      }
      return [];
    },
    async upsertTaxFees({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey, postProcessTrans,
    }) {
      let results;
      try {
        const gqlfields = fields || feeFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxFees ($item:taxFeesInputType)  {
            upsertTaxFees(upsert: $item) {
                    ${(fieldsToGqlString(gqlfields))},
                  }
                }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        const oldListData = rootGetters['base/crud/items'](baseCrudKey);
        const newListData = results.data.upsertTaxFees;
        const newList = mergeByIdNewAtTop(oldListData || [], newListData);
        const processedTransData = postProcessTrans
          ? postProcessTrans(newList) : newList;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
        return results.data.upsertTaxFees;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Tax Fees', { root: true });
      }
      return {};
    },
    async deleteTaxFees({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxFees ($id: ID!)  {
            deleteTaxFees(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTaxFees._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Tax Fees', { root: true });
      }
    },
    async bulkDeleteTaxFees({ commit, dispatch }, { upsert }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation multipleDeleteTaxFees ($upsert: taxFeesInputType!)  {
            multipleDeleteTaxFees(upsert: $upsert) {
              deletedCount,
                }
              }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        const returnObj = results.data.multipleDeleteTaxFees;
        dispatch('flashSuccess', `${returnObj.deletedCount} records deleted successfully`, { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem deleting the Tax Fees', { root: true });
      }
    },
    async multipleUpsertTaxFees({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        // ${(fieldsToGqlString({ statusCodes: '' }))},
        results = await backend.mutate({
          mutation: gql`mutation multipleUpsertTaxFees ($item:[taxFeesInputType])  {
            multipleUpsertTaxFees(upsert: $item) {
                    statusCodes
                  }
                }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        if (results.data.multipleUpsertTaxFees.statusCodes !== 200) dispatch('flashError', 'There was a problem in upserting the Tax Fees', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Tax Fees', { root: true });
      }
    },
    async bulkUpdateTaxFees({ dispatch, commit }, { upsert }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation multipleFeeUpdate ($upsert: taxFeesInputType!)  {
            multipleFeeUpdate(upsert: $upsert) {
              updatedCount,
                  }
                }`,
          variables: {
            upsert,
          },
        });
        clients.handleGQLErrors(results, commit);
        const returnedObj = results.data ? results.data.multipleFeeUpdate : {};
        dispatch('flashSuccess', `${returnedObj.updatedCount} Records updated`, { root: true });
        return returnedObj;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the transaction!', { root: true });
      }
      return {};
    },
  },
};

export default taxFee;
